import { action } from '@ember/object';
import { formatDeletedAtDate } from '../../utils/messaging/format-date';
import { on } from '@ember/modifier';
import { service } from '@ember/service';
import { t } from 'ember-intl';
import { tracked } from '@glimmer/tracking';
import AttachTooltip from 'ember-attacher/components/attach-tooltip';
import Component from '@glimmer/component';
import Message from './message.gjs';
import MessageSubtext from './message-subtext.gjs';
import SecondaryButton from 'ember-simplepractice/components/spds/action/button/secondary';
import styles from './removed-message.module.scss';
import svgJar from 'ember-svg-jar/helpers/svg-jar';

export default class ConversationMessageRemovedMessage extends Component {
  @service messaging;
  @service intl;

  @tracked showRemovedMessage = false;
  @tracked isTooltipVisible = false;

  get shouldSeeRemovedMessage() {
    return this.messaging.currentProfile.isClinician && this.args.message.isOwn;
  }

  get deletedAt() {
    return formatDeletedAtDate(this.intl, this.args.message.deletedAt);
  }

  get iconName() {
    return this.showRemovedMessage ? 'messaging-eye-crossed' : 'messaging-eye';
  }

  get tooltipText() {
    return this.showRemovedMessage
      ? this.intl.t('emc.hide_message')
      : this.intl.t('emc.show_message');
  }

  @action
  toggleRemovedMessageVisibility() {
    this.isTooltipVisible = false;
    this.showRemovedMessage = !this.showRemovedMessage;
  }

  @action
  showTooltip() {
    this.isTooltipVisible = true;
  }

  @action
  hideTooltip() {
    this.isTooltipVisible = false;
  }

  <template>
    <div class={{styles.component}} data-test-removed-message>
      <div class="removed-message-wrapper">
        {{#if this.shouldSeeRemovedMessage}}
          <SecondaryButton
            @iconOnly={{true}}
            {{on "click" this.toggleRemovedMessageVisibility}}
            {{on "mouseenter" this.showTooltip}}
            {{on "mouseleave" this.hideTooltip}}
            data-test-toggle-message-visibility
          >
            {{svgJar this.iconName}}

            <AttachTooltip
              @isShown={{this.isTooltipVisible}}
              @placement="bottom"
              @arrow={{true}}
              @class="toggle-message-visibility-tooltip"
            >
              {{this.tooltipText}}
            </AttachTooltip>
          </SecondaryButton>
        {{/if}}

        <div class="removed-message">
          {{#if this.showRemovedMessage}}
            <Message @message={{@message}} />
          {{else}}
            {{t "emc.message_removed"}}
          {{/if}}
        </div>
      </div>

      {{#if this.shouldSeeRemovedMessage}}
        {{#if this.showRemovedMessage}}
          <MessageSubtext @conversation={{@message.conversation}} @message={{@message}} />
        {{/if}}

        <span class="deleted-at" data-test-deleted-at>
          {{this.deletedAt}}
        </span>
      {{/if}}
    </div>
  </template>
}
